var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox');

function fireLoadEvent(data, cause) {
    if (data && data.event_data) {
        if(!data.event_data.action_category) {
            data.event_data.action_category = 'system';
        }

        data.event_data.action_cause = cause;
        data.ads = {
            disable_refresh: true
        };
        eventToolbox.fireAction(data);
    }
}

function fireListTracking(cause) {
    var tracking_lists = window.EDMDataStorage.tracking_lists || [];
    tracking_lists.forEach(function (list) {
        fireLoadEvent(list, cause);
    });
}

$(window).ready(function () {
    fireListTracking('page_load');
});

module.exports = {
    fireListTracking: fireListTracking
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/engagement-handler/list-engagement-handler/list-engagement-handler.js
// module id = 260
// module chunks = 36